import axios from "axios";
import { jwtClient } from "./authUtils";

export const REQUEST_RAW_DATA = "REQUEST_RAW_DATA";
const requestRawData = () => {
  return {
    type: REQUEST_RAW_DATA,
  };
};

export const RECEIVE_RAW_DATA = "RECEIVE_RAW_DATA";
const receiveRawData = (sensor, fetchPeriod) => {
  return {
    type: RECEIVE_RAW_DATA,
    sensor,
    fetchPeriod,
  };
};

export const FAILED_RAW_DATA = "FAILED_RAW_DATA";
const failedRawData = () => {
  return {
    type: FAILED_RAW_DATA,
  };
};

export const fetchRawData = (apiUrl, sensorId, fetchPeriod) => {
  return async (dispatch) => {
    dispatch(requestRawData());
    try {
      if (!fetchPeriod) {
        var d = new Date();
        var ts = Math.round(d / 1000);
        var offset = d.getTimezoneOffset() * 60;
        fetchPeriod = [ts - offset - 60 * 30 * 24 * 60, ts - offset];
      }

      var url =
        apiUrl + "/api/product/installation/:id/raw_detail/?format=json".replace(":id", sensorId);
      url += "&start=" + fetchPeriod[0] + "&end=" + fetchPeriod[1];

      const response = await jwtClient.withJWT(async (jwt) => {
        return axios.get(url, {
          headers: { Authorization: "JWT " + jwt },
        });
      });

      const sensor = response.data;
      return dispatch(receiveRawData(sensor, fetchPeriod));
    } catch {
      return dispatch(failedRawData());
    }
  };
};
